{
  "cognito": {
    "userPools": {
      "parent": {
        "url": "https://cogup-ext-parent-auth.waterford.org",
        "clientId": "64p9vkthsfne2oli7ud3rnm843"
      },
      "upstartParent": {
        "url": "https://cogup-ext-parent-auth.waterford.org",
        "clientId": "4pf9tbevrp645ulsivknpc5bio"
      },
      "newUpstartParent": {
        "url": "https://cogup-ext-parent-auth.waterford.org",
        "clientId": "6t8qda2e34goopqi6keg1pk1u0"
      }
    }
  },
  "api": {
    "region": "us-east-1",
    "key": "wIkpRlPdhJCfEsK9F8WhIB5rg5BJ1LOSaYeCDvtx",
    "url": "api.waterfordlabs.org",
    "protocol": "https"
  },
  "dashboards": {
    "url": "https://dashboard-plugin.waterford.org/wel_manager"
  },
  "reporting": {
    "jasperUrl": "https://jasper.waterford.org"
  },
  "content": {
    "url": "https://content.waterford.org",
    "cloudFrontUrl": "https://d1hsa6e2n2ycln.cloudfront.net",
    "videoTemplateId": "262"
  },
  "contentV3": {
    "url": "https://content-v3.waterford.org"
  },
  "resources": {
    "url": "https://resources.waterford.org"
  },
  "fusion": {
    "loginUrl": "https://signin.waterford.org",
    "adminLoginUrl": "https://adminsignin.waterford.org",
    "userLookupUrl": "https://api.waterford.org/user-lookup/v2"
  },
  "helpMessages": {
    "wacs": {
      "en": {
        "url": "https://resources.waterford.org/content/2177/2177.html"
      },
      "es": {
        "url": "https://resources.waterford.org/content/2178/2178.html"
      }
    }
  },
  "sentry": {
    "dsn": "https://33ec765681fc62e5bf3a6ed9b023b574@o1133904.ingest.us.sentry.io/4509127499710464",
    "environment": "prod",
    "tracesSampleRate": 0.1
  },
  "upstartRegistration": {
    "wizardCss": "https://mentor.waterford.org/upstart-registration/assets/waterford-wizard.css",
    "programsCss": "/assets/styles/forms/waterford-forms.css"
  },
  "notifications": {
    "websocketUrl": "wss://ws-api.waterfordlabs.org/notification-websockets"
  },
  "googleAnalytics": {
    "enabled": true
  },
  "recaptcha": {
    "siteKey": "6LfiAsghAAAAAOeIMwvwDmctBMSjcrlEnZEwFhHf"
  },
  "upstartLogin": {
    "signUpUrl": "https://www.waterford.org/upstart/",
    "enabled": true
  },
  "snowplow": {
    "collectorUrl": "https://snowplow.waterford.org"
  },
  "eula": {
    "en": "https://resources.waterford.org/data-source/4579/4579.html",
    "es": "https://resources.waterford.org/data-source/4580/4580.html"
  }
}
